function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M75.5384 18.994L78.8654 20.5682L75.5384 22.1423L73.9642 25.4645L72.39 22.1423L69.0679 20.5682L72.39 18.994L73.9642 15.667L75.5384 18.994Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8702 46.7593L18.0611 49.2171L12.8702 51.675L10.4124 56.8659L7.95457 51.675L2.76367 49.2171L7.95457 46.7593L10.4124 41.5732L12.8702 46.7593Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M57.3392 76.1573H25.8076C22.6785 76.1573 20.3318 73.7864 20.9498 71.2465L25.5275 52.5061C25.9959 50.594 28.0288 49.2178 30.3852 49.2178H52.7616C55.1228 49.2178 57.1509 50.594 57.6193 52.5061L62.1969 71.2465C62.8199 73.7864 60.4731 76.1573 57.3392 76.1573Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5722 72.5546C46.6312 72.5546 50.7323 68.4535 50.7323 63.3945C50.7323 58.3355 46.6312 54.2344 41.5722 54.2344C36.5132 54.2344 32.4121 58.3355 32.4121 63.3945C32.4121 68.4535 36.5132 72.5546 41.5722 72.5546Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5742 54.2295V56.528",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5742 70.2559V72.5543",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M32.4126 63.3955H34.7111",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M48.439 63.3945H50.7374",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5742 63.3943V58.9277",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M45.5403 45.0312H37.5005V48.8942H45.5403V45.0312Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M54.5707 45.0314H28.5728C25.6611 45.0314 23.2998 42.6701 23.2998 39.7584V38.2422H59.8437V39.7584C59.8437 42.6701 57.4873 45.0314 54.5707 45.0314Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M52.6718 17.377C45.6315 20.2452 39.8032 21.5731 25.5246 22.9735C19.8991 23.5239 15.8575 24.9581 13.0278 26.4984",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M52.5513 17.3771C52.5513 17.3771 54.5166 15.4842 55.1105 14.2142C56.3032 11.6405 57.2931 8.36663 62.962 5.74463C64.6521 4.96237 66.7478 3.94351 68.1046 2.82324C68.1046 2.82324 66.8105 7.34777 63.3049 11.4184C60.3255 14.8613 52.5513 17.3771 52.5513 17.3771Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M43.9741 15.6676C43.8679 12.9056 43.7665 10.2111 47.7406 5.72039C48.9236 4.38282 50.3722 2.67828 51.0917 1.15723C51.0917 1.15723 52.0188 5.7059 50.7006 10.6892C49.5851 14.9046 43.6265 20.0907 43.6265 20.0907",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5801 18.0042C33.8457 14.8704 35.0142 10.6356 39.3118 6.70014C40.5914 5.52675 42.1704 4.02018 43.0396 2.50879C43.0396 2.50879 43.3052 7.888 41.4171 13.1224C39.8188 17.5503 33.5801 21.7079 33.5801 21.7079",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2991 19.7769C23.048 16.981 23.7916 12.3213 26.8337 8.48729C27.7415 7.34771 28.8473 5.87977 29.3543 4.47461C29.3543 4.47461 30.4022 9.21643 29.6006 13.9969C28.9246 18.0482 23.7192 22.959 23.7192 22.959",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M43.7764 20.1387C43.7764 20.1387 46.5239 21.3748 47.7166 22.413C50.1262 24.5135 50.1889 26.1505 56.6401 27.0341C58.562 27.2997 60.9763 27.6667 62.7775 28.3524C62.7775 28.3524 61.8359 24.5715 56.5677 21.6984C55.1191 20.9064 53.26 20.467 51.4106 20.2304",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M39.4403 24.2432C41.1594 24.8516 43.0764 25.6436 44.9741 26.6383C49.8414 29.1927 52.6759 32.8915 52.6759 32.8915C52.6759 32.8915 46.5579 31.9113 44.8534 31.4042C41.3911 30.3757 39.2086 30.3854 35.6884 26.4934C34.3895 25.0641 33.8873 24.0646 33.2837 22.5049",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1069 24.0645C20.1069 24.0645 22.333 25.7159 23.2794 26.9327C25.2013 29.4002 25.8193 31.322 30.7543 32.8914C34.8877 34.2048 36.2349 33.4708 38.8956 33.3598C38.8956 33.3598 36.3701 31.5828 32.1208 27.9178C30.6722 26.672 28.6876 26.0346 26.7899 25.4841",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function Svg4Franqueado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 78,
    viewBox: "0 0 82 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Franqueado);
export default __webpack_public_path__ + "static/media/4-franqueado.272995535c1bf0fa67f4f51346a57892.svg";
export { ForwardRef as ReactComponent };